import { render, staticRenderFns } from "./RecaptchaNoticeComponent.vue?vue&type=template&id=76340bf2"
import script from "./RecaptchaNoticeComponent.vue?vue&type=script&lang=js"
export * from "./RecaptchaNoticeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports